import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'antd';
import { useRegisterValues } from 'elements/Account/providers/RegisterProvider';
import { useFireEvent } from 'hooks/useFireEvent';
import * as Styled from './styles';
import { UserTypes } from 'constants/account/user-types';
import { StepViewerEvents } from 'constants/app/eventbus-events';
import BriefCase from 'assets/images/briefcase.png';
import Layers from 'assets/images/layers.png';
import Roller from 'assets/images/roller.png';

const { Meta } = Card;

const REGISTRATION_OPTIONS = [
  {
    id: 1,
    type: UserTypes.Collector,
    label: 'account.userType',
    description: 'account.registerCollectorDescription',
    image: Layers
  },
  {
    id: 2,
    type: UserTypes.Creator,
    label: 'account.creatorType',
    description: 'account.registerCreatorDescription',
    image: Roller
  },
  {
    id: 3,
    type: UserTypes.Company,
    label: 'account.companyType',
    description: 'account.registerCompanyDescription',
    image: BriefCase
  }
];

export const RegisterFirstStep = () => {
  const { t } = useTranslation();
  const { selectedUserType, setSelectedUserType, eventId } =
    useRegisterValues();
  const { fireEvent } = useFireEvent();
  const handleClick = (id: number) => {
    setSelectedUserType(id);
  };

  useEffect(() => {
    fireEvent({
      key: selectedUserType
        ? StepViewerEvents.EnableProceeding
        : StepViewerEvents.DisableProceeding,
      id: eventId
    });
  }, [selectedUserType]);

  return (
    <div>
      {REGISTRATION_OPTIONS.map(option => (
        <Fragment key={option.id}>
          <Styled.UserCardWrapper $isActive={selectedUserType === option.id}>
            <Card onClick={() => handleClick(option.id)}>
              <Meta
                avatar={<img src={option.image} alt={option.type} />}
                title={t(option.label)}
                description={t(option.description)}
              />
            </Card>
          </Styled.UserCardWrapper>
        </Fragment>
      ))}
    </div>
  );
};
